import { render, staticRenderFns } from "./ProductoTiendaConfigTable.vue?vue&type=template&id=43b126cc&"
import script from "./ProductoTiendaConfigTable.vue?vue&type=script&lang=js&"
export * from "./ProductoTiendaConfigTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports